import { Flex, Text } from '@chakra-ui/react';
import { ReactComponent as HorizontalLayoutIcon } from 'assets/icons/quizzes_widget_horizontal_layout.svg';
import { ReactComponent as VerticalLayoutIcon } from 'assets/icons/quizzes_widget_vertical_layout.svg';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

import { MultipleChoicesType, MultipleChoicesWidgetData } from '../../MultipleChoicesWidget.types';

export const ChoiceLayout = () => {
  const { t } = useTranslation('editor_widget_toolbar', {
    keyPrefix: 'multipleChoicesToolbar',
    useSuspense: false,
  });

  const { updateWidget } = useWidget<MultipleChoicesWidgetData>();

  const handleClick = useCallback(
    (type: MultipleChoicesType) => {
      updateWidget({
        type,
      });
    },
    [updateWidget],
  );

  return (
    <Flex flexDir={'row'} gap={4}>
      <Flex
        as='button'
        flexDir={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        overflow={'hidden'}
        gap={2}
        onClick={() => handleClick(MultipleChoicesType.Horizontal)}
      >
        <Flex
          border={'1px solid #dbdbdb'}
          borderRadius={'base'}
          w={'full'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <HorizontalLayoutIcon />
        </Flex>
        <Text fontSize={'sm'} color='font.500'>
          {t('settingsSideBar.multipleChoices.layout.horizontalAlignment')}
        </Text>
      </Flex>
      <Flex
        as='button'
        flexDir={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        overflow={'hidden'}
        gap={2}
        onClick={() => handleClick(MultipleChoicesType.Vertical)}
      >
        <Flex
          border={'1px solid #dbdbdb'}
          borderRadius={'base'}
          w={'full'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <VerticalLayoutIcon />
        </Flex>
        <Text fontSize={'sm'} color='font.500'>
          {t('settingsSideBar.multipleChoices.layout.verticalAlignment')}
        </Text>
      </Flex>
    </Flex>
  );
};
